import {ApiService} from "../api";
import {Share} from "../../types";
import {AxiosResponse} from "axios";
import {ShareRequestDTO} from "../../types/DTOs/ShareRequestDTO";
import {ShareResponseDTO} from "../../types/DTOs/ShareResponseDTO";

export class ShareAPI extends ApiService {
    private constructor() {
        super();
    }

    async createShare(cvVersionId: string, data: ShareRequestDTO): Promise<ShareResponseDTO> {
        const response: AxiosResponse<ShareResponseDTO> = await this.api.post(`/share/cv/${cvVersionId}`, data);
        return response.data;
    }

    async getMyShares(): Promise<Share[]> {
        const response: AxiosResponse<Share[]> = await this.api.get('/share/my-shares');
        return response.data;
    }

    async deleteShare(token: string): Promise<void> {
        await this.api.delete(`/share/${token}`);
    }
}